import { IPhongUuTienBuoi } from "../../../model/respone/category/IPhongUuTienBuoi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhongUuTienBuoiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPhongUuTienBuoi[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IPhongUuTienBuoi | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IPhongUuTienBuoi,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const ePhongUuTienBuoiActionIds = generateActionTypeIds(ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI");
export type IPhongUuTienBuoiActionTypes = IGenericActionType<typeof ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI">;
